import { createTheme, ThemeProvider } from '@mui/material/styles';
import { supabase, host } from '../supabaseClient.js';
import { useEffect, useState, createContext, useContext, useRef, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useCode } from '../contexts/Code';

const ThemeContext = createContext();

async function getCompany(companyId) {
  const { data, error } = await supabase
    .from('companies')
    .select()
    .eq('id', companyId)
    .limit(1)
    .single();

  const logo = host + '/storage/v1/object/public/logos/' + companyId + '.png'

  let theme;

  if (data) {
    theme = createTheme({
      palette: {
        
        mode: 'dark',
        primary: {
          main: data.color,
        },
      },
    });
  } else {
    // Si no se encuentra la compañía, usa un color por defecto
    theme = createTheme({
      palette: {
        mode: 'dark',
        primary: {
          main: '#2196f3', // Color por defecto (puedes cambiarlo según tus necesidades)
        },
      },
    });
  }

  return { theme, logo: logo };
}


const ThemeClient = ({ children }) => {
  const logoUrlRef = useRef('');
  const themeRef = useRef(null);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const { code } = useCode();

  const location = useLocation();
  const isWithinAdminRoute = location.pathname.startsWith('/admin');

  useEffect(() => {
    async function fetchCompanyData() {
      const { logo, theme } = await getCompany(code);

      logoUrlRef.current = logo;
      themeRef.current = theme;
      setIsDataLoaded(true);
    }

    if (!isDataLoaded && !isWithinAdminRoute) {
      fetchCompanyData();
    } else {
      setIsDataLoaded(true);
    }
  }, [code, isDataLoaded, isWithinAdminRoute]);

  if (!isDataLoaded && !isWithinAdminRoute) {
    return null; // Mostrar un estado de carga o cualquier otro componente mientras se cargan los datos
  }

  return isWithinAdminRoute ? <>{children}</> : (
    <ThemeProvider theme={themeRef.current}>
      <ThemeContext.Provider value={{ theme: themeRef.current, logo: logoUrlRef.current }}>
        {children}
      </ThemeContext.Provider>
    </ThemeProvider>
  );
};

const useThemeClientLogo = () => useContext(ThemeContext);

export { ThemeClient, useThemeClientLogo };
